import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Paper,
  InputAdornment,
  IconButton,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { getUserProfile } from "../api/user";
import { changePassword } from "../api/auth";
import { toast, ToastContainer } from "react-toastify";
const ChangePassword = () => {
  const [showOldPassword, setShowOldPassword] = React.useState(false);
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [profile, setProfile] = useState({});
  const [formData, setFormData] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await getUserProfile();
      setProfile(data);
    };
    fetchData();
  }, []);
  const togglePasswordVisibility = (type) => {
    switch (type) {
      case "old":
        setShowOldPassword(!showOldPassword);
        break;
      case "new":
        setShowNewPassword(!showNewPassword);
        break;
      case "confirm":
        setShowConfirmPassword(!showConfirmPassword);
        break;
      default:
        break;
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => {
      const keys = name.split(".");
      if (keys.length > 1) {
        return {
          ...prevData,
          [keys[0]]: {
            ...prevData[keys[0]],
            [keys[1]]: value,
          },
        };
      } else {
        return {
          ...prevData,
          [name]: value,
        };
      }
    });
  };
  const handleSaveChanges = async () => {
    if (!formData.old_password || !formData.new_password || !formData.confirm_password) {
      toast.error("Please fill in all password fields");
      return;
    }
    if (formData?.new_password !== formData?.confirm_password) {
      toast.error("Password doesn't Match");
    } else {
        const { confirm_password, ...restFormData } = formData;
        try {
          const {data} = await changePassword(restFormData);

            if (data?.message) {
              toast.success(data?.message);
            }
        } catch (error) {
            toast.error("Incorrect Old Password");
            
        }
   
    }
  };
  return (
    <Box sx={{ padding: 3, flexGrow: 1, height: "90vh", overflow: "auto" }}>
      <Box
        sx={{
          paddingLeft: "10px",
          display: "flex",
          alignItems: "center",
          gap: 1,
          marginBottom: 2,
          height: "80px",
          backgroundColor: "#FFF",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <AccountCircleIcon />
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          Profile
        </Typography>
      </Box>

      <Box>
        <Paper
          sx={{
            padding: "40px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
          }}
        >
          <Box mb={2}>
            <Typography
              variant="body2"
              fontWeight={600}
              color="text.secondary"
              mb={1}
            >
              Your Email Address
            </Typography>
            <TextField
              fullWidth
              value={profile?.email}
              disabled={true}
              InputProps={{
                disableUnderline: true,
                sx: { backgroundColor: "#F1F3F4" },
              }}
            />
          </Box>

          <Box mb={2}>
            <Typography
              variant="body2"
              fontWeight={600}
              color="text.secondary"
              mb={1}
            >
              Your Old Password
            </Typography>
            <TextField
              fullWidth
              value={formData?.old_password}
              name="old_password"
              onChange={(e) => handleChange(e)}
              type={showOldPassword ? "text" : "password"}
              placeholder="Your Old Password"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => togglePasswordVisibility("old")}>
                      {showOldPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
                disableUnderline: true,
                sx: { backgroundColor: "#F1F3F4" },
              }}
            />
          </Box>

          <Box mb={2}>
            <Typography
              variant="body2"
              fontWeight={600}
              color="text.secondary"
              mb={1}
            >
              Your New Password
            </Typography>
            <TextField
              fullWidth
              value={formData?.new_password}
              name="new_password"
              onChange={(e) => handleChange(e)}
              type={showNewPassword ? "text" : "password"}
              placeholder="Your New Password"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => togglePasswordVisibility("new")}>
                      {showNewPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
                disableUnderline: true,
                sx: { backgroundColor: "#F1F3F4" },
              }}
            />
          </Box>

          <Box mb={3}>
            <Typography
              variant="body2"
              fontWeight={600}
              color="text.secondary"
              mb={1}
            >
              Confirm New Password
            </Typography>
            <TextField
              fullWidth
              value={formData?.confirm_password}
              name="confirm_password"
              onChange={(e) => handleChange(e)}
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm New Password"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => togglePasswordVisibility("confirm")}
                    >
                      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
                disableUnderline: true,
                sx: { backgroundColor: "#F1F3F4" },
              }}
            />
          </Box>

          <Button
            variant="contained"
            fullWidth
            sx={{
              backgroundColor: "#161ab3",
              color: "#fff",
              fontWeight: "bold",
              padding: "10px 0",
              "&:hover": {
                backgroundColor: "#161ab3",
              },
            }}
            onClick={handleSaveChanges}
          >
            Save Changes
          </Button>
        </Paper>
      </Box>
      <ToastContainer />
    </Box>
  );
};

export default ChangePassword;
